import { mapFarms } from './mapMockData';
import { MOCK_STATIONS } from './mockStationsData';

const sortByStationCode = (a, b) => {
  const aCode = String(a?.stationCode || '');
  const bCode = String(b?.stationCode || '');
  return aCode.localeCompare(bCode);
};

const normalizeStation = (station) => ({
  ...station,
  stationType: station?.stationType || station?.sensorType || null,
  sensorType: station?.sensorType || station?.stationType || null,
  farmId: station?.farmId || station?.projectId || null,
  farmName: station?.farmName || station?.projectTitle || null,
});

const STATIONS = (Array.isArray(MOCK_STATIONS) ? MOCK_STATIONS : [])
  .map(normalizeStation)
  .sort(sortByStationCode);

const FARMS = (Array.isArray(mapFarms) ? mapFarms : []).map((farm) => ({
  id: farm.id,
  name: farm.name,
  location: farm.location,
}));

const normalizeStatusFilter = (status) => {
  if (!status || status === 'all') return null;
  if (Array.isArray(status)) {
    const normalized = status
      .map((value) => String(value || '').trim())
      .filter(Boolean);
    return normalized.length > 0 ? normalized : null;
  }
  const normalized = String(status).trim();
  return normalized ? [normalized] : null;
};

export const getAllStations = () => STATIONS.slice();

export const getAllFarms = () => FARMS.slice();

export const findStationById = (stationId) => {
  if (!stationId) return null;
  const id = String(stationId);
  return STATIONS.find((station) => String(station?.id) === id) || null;
};

export const filterStations = ({
  farmId = 'all',
  status = 'all',
  stationType = 'all',
  searchQuery = '',
} = {}) => {
  const statusFilters = normalizeStatusFilter(status);
  const normalizedFarmId = typeof farmId === 'string' ? farmId.trim() : farmId;
  const normalizedStationType = typeof stationType === 'string' ? stationType.trim() : stationType;
  const query = String(searchQuery || '').trim().toLowerCase();

  return STATIONS.filter((station) => {
    if (normalizedFarmId && normalizedFarmId !== 'all' && station.farmId !== normalizedFarmId) {
      return false;
    }

    if (statusFilters && !statusFilters.includes(station.status)) {
      return false;
    }

    const stationKind = station.stationType || station.sensorType;
    if (normalizedStationType && normalizedStationType !== 'all' && stationKind !== normalizedStationType) {
      return false;
    }

    if (query) {
      const haystack = [
        station.stationCode,
        station.locationDescription,
        station.projectTitle,
        station.farmName,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (!haystack.includes(query)) {
        return false;
      }
    }

    return true;
  });
};
